/**
 * Created by christiancueni on 03/08/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import {Action} from '@ngrx/store';

import {FormUser, ProfileUser, User} from '../models';
import {type} from '../shared/util';
import {HttpErrorResponse} from "@angular/common/http";

export const UserActionTypes = {
    LOAD_USERS: type("[User] Load users"),
    LOAD_USERS_FAIL: type("[User] Load users failed"),
    LOAD_USERS_SUCCESS: type("[User] Load users success"),
    LOAD_USER: type("[User] Load user"),
    LOAD_USER_FAIL: type("[User] Load user failed"),
    LOAD_USER_SUCCESS: type("[User] Load user success"),
    ADD_USER: type("[User] Add"),
    ADD_USER_FAIL: type("[User] Add failed"),
    ADD_USER_SUCCESS: type("[User] Add success"),
    UPDATE_USER: type("[User] Update"),
    UPDATE_USER_FAIL: type("[User] Update failed"),
    UPDATE_USER_SUCCESS: type("[User] Update success"),
    DELETE_USER_USER_ACTION: type("[User] Delete user user action"),
    DELETE_USER_CONFIRMATION: type("[User] Delete user confirm action"),
    DELETE_USER_CANCEL: type("[User] Delete user cancel action"),
    DELETE_USER: type("[User] Delete user"),
    DELETE_USERS_USER_ACTION: type("[User] Delete users user action"),
    DELETE_USERS_CONFIRMATION: type("[User] Delete users confirmation"),
    DELETE_USERS_CANCEL: type("[User] Delete users cancel"),
    DELETE_USERS: type("[User] Delete users"),
    DELETE_USERS_SUCCESS: type("[User] Delete users success"),
    DELETE_USERS_FAIL: type("[User] Delete users fail"),
    SET_USER: type("[User] set"),
    UNSET_USER: type("[User] unset"),
    IMPORT_USERS: type("[User] import"),
    UPDATE_PROFILE: type("[User] Profile Update"),
    UPDATE_PROFILE_FAIL: type("[User] Profile Update failed"),
    UPDATE_PROFILE_SUCCESS: type("[User] Profile Update success"),
    USER_FORM_ERRORS: type('[User] User Form Errors'),
    USERS_EXPORT: type('[User] User Export'),
    IMPORT_USERS_INFO: type('[User] User Import Info'),
    IMPORT_USERS_RESET_INFO: type('[User] User Import Reset Info'),
    RESET_USERS: type('[Users] Reset'),
    SHOW_DELETE_PROFILE_MODAL: type('[User] Show delete profile modal'),
    HIDE_DELETE_PROFILE_MODAL: type('[User] Hide delete profile modal'),
    DELETE_ACCOUNT: type('[User] Delete account'),
    INVITE_FRIEND: type('[User] Invite friend')
};

export class UsersLoadAction implements Action {
    type = UserActionTypes.LOAD_USERS;

    constructor() {
    }
}

export class UsersLoadFailAction implements Action {
    type = UserActionTypes.LOAD_USERS_FAIL;

    constructor(public payload: string) {
    }
}

export class UsersLoadSuccessAction implements Action {
    type = UserActionTypes.LOAD_USERS_SUCCESS;

    constructor(public payload: User[]) {
    }
}

export class LoadUserAction implements Action {
    type = UserActionTypes.LOAD_USER;

    constructor(public payload: number) {
    }
}

export class LoadUserFailAction implements Action {
    type = UserActionTypes.LOAD_USER_FAIL;

    constructor(public payload: HttpErrorResponse) {
    }
}

export class LoadUserSuccessAction implements Action {
    type = UserActionTypes.LOAD_USER_SUCCESS;

    constructor(public payload: User) {
    }
}

export class AddUserAction implements Action {
    type = UserActionTypes.ADD_USER;

    constructor(public payload: FormUser) {
    }
}

export class AddUserFailAction implements Action {
    type = UserActionTypes.ADD_USER_FAIL;

    constructor(public payload: string) {
    }
}

export class AddUserSuccessAction implements Action {
    type = UserActionTypes.ADD_USER_SUCCESS;

    constructor(public payload: User) {
    }
}

export class UpdateUserAction implements Action {
    type = UserActionTypes.UPDATE_USER;

    constructor(public payload: FormUser) {
    }
}

export class UpdateUserFailAction implements Action {
    type = UserActionTypes.UPDATE_USER_FAIL;

    constructor(public payload: string) {
    }
}

export class UpdateUserSuccessAction implements Action {
    type = UserActionTypes.UPDATE_USER_SUCCESS;

    constructor(public payload: User) {
    }
}

export class DeleteUsersUserAction implements Action {
    type = UserActionTypes.DELETE_USERS_USER_ACTION;

    constructor(public payload: number[]) {
    }
}

export class DeleteUsersConfirmationAction implements Action {
    type = UserActionTypes.DELETE_USERS_CONFIRMATION;

    constructor(public payload: number[]) {
    }
}

export class DeleteUsersCancelAction implements Action {
    type = UserActionTypes.DELETE_USERS_CANCEL;

    constructor() {
    }
}

export class DeleteUserUserAction implements Action {
    type = UserActionTypes.DELETE_USER_USER_ACTION;

    constructor(public payload: number) {
    }
}

export class DeleteUserConfirmationAction implements Action {
    type = UserActionTypes.DELETE_USER_CONFIRMATION;

    constructor(public payload: number) {
    }
}

export class DeleteUserCancelAction implements Action {
    type = UserActionTypes.DELETE_USER_CANCEL;

    constructor() {
    }
}

export class DeleteUserAction implements Action {
    type = UserActionTypes.DELETE_USER;

    constructor(public payload: number) {
    }
}

export class DeleteUsersAction implements Action {
    type = UserActionTypes.DELETE_USERS;

    constructor(public payload: { userIds: number[], singleUser: boolean }) {
    }
}

export class DeleteUsersSuccessAction implements Action {
    type = UserActionTypes.DELETE_USERS_SUCCESS;

    constructor(public payload: Object) {
    }
}

export class DeleteUsersFailAction implements Action {
    type = UserActionTypes.DELETE_USERS_FAIL;

    constructor(public payload: string) {
    }
}

export class SetUserAction implements Action {
    type = UserActionTypes.SET_USER;

    constructor(public payload: User) {
    }
}

export class UnsetUserAction implements Action {
    type = UserActionTypes.UNSET_USER;

    constructor() {
    }
}

export class ImportUsersAction implements Action {
    type = UserActionTypes.IMPORT_USERS;

    constructor(public payload: any) {
    }
}


export class UpdateProfileAction implements Action {
    type = UserActionTypes.UPDATE_PROFILE;

    constructor(public payload: ProfileUser) {
    }
}

export class UpdateProfileFailAction implements Action {
    type = UserActionTypes.UPDATE_PROFILE_FAIL;

    constructor(public payload: string) {
    }
}

export class UpdateProfileSuccessAction implements Action {
    type = UserActionTypes.UPDATE_PROFILE_SUCCESS;

    constructor(public payload: User) {
    }
}

export class UpdateUserFormErrorsAction implements Action {
    type = UserActionTypes.USER_FORM_ERRORS;

    constructor(public payload: Object) {
    }
}

export class ExportUsersAction implements Action {
    type = UserActionTypes.USERS_EXPORT;

    constructor() {
    }
}

export class ImportUserInfoAction implements Action {
    type = UserActionTypes.IMPORT_USERS_INFO;

    constructor(public payload: Object) {
    }
}

export class ImportUserResetInfoAction implements Action {
    type = UserActionTypes.IMPORT_USERS_RESET_INFO;

    constructor() {
    }
}

export class UsersResetAction implements Action {
    type = UserActionTypes.RESET_USERS;

    constructor() {
    }
}

export class ShowDeleteProfileModalAction implements Action {
    type = UserActionTypes.SHOW_DELETE_PROFILE_MODAL;

    constructor() {
    }
}

export class HideDeleteProfileModalAction implements Action {
    type = UserActionTypes.HIDE_DELETE_PROFILE_MODAL;

    constructor() {
    }
}

export class DeleteAccountAction implements Action {
    type = UserActionTypes.DELETE_ACCOUNT;

    constructor() {
    }
}

export class InviteFriendAction implements Action {
    type = UserActionTypes.INVITE_FRIEND;

    constructor(public payload: string) {
    }
}

export type UserActions =
    UsersLoadAction
    | UsersLoadFailAction
    | UsersLoadSuccessAction
    | AddUserAction
    | AddUserFailAction
    | AddUserSuccessAction
    | DeleteUsersUserAction
    | DeleteUsersConfirmationAction
    | DeleteUsersCancelAction
    | DeleteUserUserAction
    | DeleteUserConfirmationAction
    | DeleteUserCancelAction
    | DeleteUserAction
    | DeleteUsersAction
    | DeleteUsersSuccessAction
    | DeleteUsersFailAction
    | SetUserAction
    | UnsetUserAction
    | ImportUsersAction
    | UpdateUserAction
    | UpdateUserSuccessAction
    | UpdateUserFailAction
    | UpdateProfileAction
    | UpdateProfileSuccessAction
    | UpdateUserFailAction
    | UpdateUserFormErrorsAction
    | ExportUsersAction
    | ImportUserInfoAction
    | ImportUserResetInfoAction
    | UsersResetAction
    | ShowDeleteProfileModalAction
    | HideDeleteProfileModalAction
    | DeleteAccountAction
    | InviteFriendAction;





